import { createContext, useEffect, useReducer } from "react";

import axios from "../utils/axios";
import PlanReducer from "../reducers/PlanReducer";
import { isValidToken, setSession } from "../utils/jwt";
import { PlanConstants } from "../constants/index";
import { saveFile } from "../utils/common";
const initialState = {
  isLoading: true,
  plans: [],
  paging: {
    totalNumberOfRecords: 0,
    totalNumberOfPages: 0,
    pageNumber: 0,
    pageSize: 0,
  },
  hasError: false,
  errorMessage: "",
  planSearchResults: [],
  isLoadingDownload: false,
  planAutoSearchResults: {
    data: [],
    paging: {
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 0,
      pageSize: 0,
      totalNumberOfPages: 0,
      totalNumberOfRecords: 0,
    },
  },
  plan: {},
  isUpload: false,
  uploadError: false,
  uploadSuccess: false,
  autoSearchLoading: false,
  isLoading: true,
  isLoadingAutoSearch: true,
  downloadFileType: "",
  planRate: {
    planAmt: 0,
    serviceTaxAmount: 0,
    finalInvoiceAmt: 0,
  },
  uploadErrors: [],
};
const initPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

const PlanContext = createContext({
  ...initialState,
  getAllPlan: () => {},
  addPlan: () => {},
  searchPlan: () => {},
  autoSearchPlan: () => {},
  getPlan: () => {},
  updatePlan: () => {},
  downloadFile: () => {},
  sampleFile: () => {},
  uploadFile: () => {},
  getPlanRateWithTax: () => {},
  deletePlan: () => {},
});

function PlanProvider({ children }) {
  const [state, dispatch] = useReducer(PlanReducer, initialState);

  const getAllPlan = async (payload) => {
    try {
      dispatch({
        type: PlanConstants.FETCH_PLAN_REQUEST,
      });
      const response = await axios.post("/radius/plan/list", payload);
      dispatch({
        type: PlanConstants.FETCH_PLAN_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (exception) {
      dispatch({
        type: PlanConstants.FETCH_PLAN_FAILURE,
      });
    }
  };
  const searchPlan = async () => {
    try {
      const response = await axios.post("/radius/plan/search", initPayload);
      dispatch({
        type: PlanConstants.PLAN_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: PlanConstants.PLAN_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: PlanConstants.PLAN_SEARCH_FAILURE,
      });
    }
  };
  const autoSearchPlan = async (payload) => {
    try {
      const response = await axios.post("/radius/plan/auto-search", payload);
      dispatch({
        type: PlanConstants.PLAN_AUTO_SEARCH_REQUEST,
      });
      console.log(response.data, "response.data");
      dispatch({
        type: PlanConstants.PLAN_AUTO_SEARCH_SUCCESS,
        payload: response.data,
      });
    } catch (exception) {
      dispatch({
        type: PlanConstants.PLAN_AUTO_SEARCH_FAILURE,
      });
    }
  };
  const addPlan = async (payload) => {
    const response = await axios.post("/radius/plan/add", payload);
    dispatch({
      type: PlanConstants.ADD_PLAN_REQUEST,
    });
    dispatch({
      type: PlanConstants.ADD_PLAN_SUCCESS,
      payload: response.data,
    });
  };

  const getPlan = async (id) => {
    const response = await axios.get("/radius/plan/" + id);
    dispatch({
      type: PlanConstants.GET_PLAN_REQUEST,
    });

    dispatch({
      type: PlanConstants.GET_PLAN_SUCCESS,
      payload: response.data,
    });
    return response.data;
  };

  const updatePlan = async (payload) => {
    const response = await axios.put("/radius/plan/update/" + payload.planId, payload);
    dispatch({
      type: PlanConstants.UPDATE_PLAN_REQUEST,
    });
    dispatch({
      type: PlanConstants.UPDATE_PLAN_SUCCESS,
      payload: response.data,
    });
  };

  const deletePlan = async (planId) => {
    try {
      dispatch({
        type: PlanConstants.DELETE_PLAN_REQUEST,
      });
      const response = await axios.put("/radius/plan/delete/" + planId);
      dispatch({
        type: PlanConstants.UPDATE_PLAN_SUCCESS,
        payload: response.data,
      });
    } catch (err) {
      dispatch({
        type: PlanConstants.DELETE_PLAN_FAILURE,
      });
      throw err;
    }
  };

  const downloadFile = async (fileType, payload) => {
    dispatch({
      type: PlanConstants.DOWNLOAD_PLAN_REQUEST,
      payload: {
        fileType: fileType,
      },
    });
    const response = await axios.post("/radius/plan/export/" + fileType, payload, {
      responseType: "blob",
    });
    console.log(response.headers, "filename");
    //const filename = response.headers.get("content-disposition").split('"');

    await saveFile(response.data, "plan." + fileType);

    dispatch({
      type: PlanConstants.DOWNLOAD_PLAN_SUCCESS,
      payload: response.data,
    });
  };

  const sampleFile = async (fileType) => {
    dispatch({
      type: PlanConstants.DOWNLOAD_PLAN_REQUEST,
      payload: { fileType: fileType },
    });
    const response = await axios.get("/radius/plan/sample/" + fileType, {
      responseType: "blob",
    });

    await saveFile(response.data, "sample_plan." + fileType);

    dispatch({
      type: PlanConstants.DOWNLOAD_PLAN_SUCCESS,
      payload: response.data,
    });
  };
  const parseErrors = (errorMessage) => {
    if (!errorMessage) return [];

    // Remove fixed prefix
    const cleaned = errorMessage.replace("Unknown Error Occured: ", "");

    // Split by each occurrence of "[Row Number"
    const chunks = cleaned.split(/\[(?=Row Number)/).filter(Boolean);

    return chunks.map((chunk) => {
      const row = chunk.match(/Row Number:\s*(\d+)/)?.[1] || "-";
      const cell = chunk.match(/Cell Number:\s*(\d+)/)?.[1] || "-";
      const message = chunk.match(/Message:\s*(.*)/)?.[1] || "Unknown error";

      return { row, cell, message };
    });
  };
  const uploadFile = async (payload) => {
    try {
      dispatch({
        type: PlanConstants.UPLOAD_PLAN_REQUEST,
      });
      const response = await axios({
        url: "/radius/plan/upload",
        method: "POST",
        data: payload,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      dispatch({
        type: PlanConstants.UPLOAD_PLAN_SUCCESS,
        payload: response.data,
      });
    } catch (error) {
      console.log("errr", error);
      dispatch({
        type: PlanConstants.UPLOAD_PLAN_FAILURE,
        payload: parseErrors(error?.message || ""),
      });
    }
  };
  const getPlanRateWithTax = async (planId, rateId, msoId, stateName) => {
    dispatch({
      type: PlanConstants.GET_PLAN_RATE_REQUEST,
    });
    const response = await axios.get(`/radius/plan/rate/${planId}/${rateId}/${msoId}/${stateName}`);
    console.log(response.data, "response4rrrrrr");
    dispatch({
      type: PlanConstants.GET_PLAN_RATE_SUCCESS,
      payload: response.data,
    });
    return response.data;
  };

  return (
    <PlanContext.Provider
      value={{
        ...state,
        getAllPlan,
        addPlan,
        searchPlan,
        autoSearchPlan,
        getPlan,
        updatePlan,
        downloadFile,
        sampleFile,
        uploadFile,
        getPlanRateWithTax,
        deletePlan,
      }}
    >
      {children}
    </PlanContext.Provider>
  );
}

export { PlanContext, PlanProvider };
